import { useState } from "react";
import "./CreateUser.css";
import ToggleViews from "../../ui/toggleViews/ToggleViews";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomSelect from "../../ui/select/Select";
import CustomButton from "../../ui/button/Button";
import PermissionsSelector from "./PermissionsSelector";
import { createUser, fetchPermitHolder } from "../functions/Functions";

const CreateUser = ({
  fieldsAddUser,
  perfiles,
  companies,
  typeWorks,
  language,
  permissions,
  projects,
  clients,
  API_URL,
}) => {
  const initialPayload = {
    correo: null,
    empresa: null,
    id: null,
    lenguaje: null,
    nombre: null,
    perfil: null,
    permisos: [], // Asume que inicialmente está vacío
    userName: null,
  };

  const [payload, setPayload] = useState({
    ...initialPayload,
  });

  const [permisionarios, setPermisionarios] = useState([]);

  const [payloadtoSend, setPayloadToSend] = useState({
    ...initialPayload,
    permisos: permissions,
    configuracionSesionNxt: {
      proyecto: null,
      cliente: null,
      permisionario: null,
      tipoTrabajo: null,
      empresa: null,
      divisionCFE: null,
      directorOperaciones: false,
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "perfil") {
      const perfilSeleccionado = perfiles.find(
        (perfil) => perfil.name === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        perfil: perfilSeleccionado || null, // Asegúrate de que nunca sea undefined
      }));
    } else if (name === "lenguaje") {
      const lenguajeSeleccionado = language.find(
        (lang) => lang.prefix === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        lenguaje: lenguajeSeleccionado || null, // Asegúrate de que nunca sea undefined
      }));
    } else if (name === "proyecto") {
      const proyectoSeleccionado = projects.find(
        (project) => project.id === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        configuracionSesionNxt: {
          ...prev.configuracionSesionNxt,
          proyecto: proyectoSeleccionado || null,
        }, // Asegúrate de que nunca sea undefined
      }));
    } else if (name === "empresa") {
      const empresaSeleccionada = companies.find(
        (company) => company.id === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        configuracionSesionNxt: {
          ...prev.configuracionSesionNxt,
          empresa: empresaSeleccionada || null,
        }, // Asegúrate de que nunca sea undefined
      }));
    } else if (name === "cliente") {
      const clienteSeleccionado = clients.find((client) => client.id === value);
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        configuracionSesionNxt: {
          ...prev.configuracionSesionNxt,
          cliente: clienteSeleccionado || null,
        }, // Asegúrate de que nunca sea undefined
      }));
      if (value) {
        // Llama al endpoint para obtener los permisionarios
        try {
          const permisionariosData = fetchPermitHolder(
            API_URL,
            setPermisionarios,
            value
          );
          // Mapear los permisionarios al formato esperado por CustomSelect
          const options = permisionariosData.map((permisionario) => ({
            value: permisionario.id, // Usar el ID como valor único
            name: permisionario.razonSocial, // Mostrar la razón social
          }));
          setPermisionarios(options); // Actualiza las opciones
        } catch (error) {
          console.error("Error al obtener permisionarios:", error);
        }
      } else {
        setPermisionarios([]); // Limpia las opciones si el cliente está vacío
      }
    } else if (name === "permisionario") {
      const permisionarioSeleccionado = permisionarios.find(
        (permisionario) => permisionario.id === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        configuracionSesionNxt: {
          ...prev.configuracionSesionNxt,
          permisionario: permisionarioSeleccionado || null,
        }, // Asegúrate de que nunca sea undefined
      }));
    } else if (name === "tipoTrabajo") {
      const tipoTrabajoSeleccionado = typeWorks.find(
        (typeWork) => typeWork.id === value
      );
      setPayload((prev) => ({
        ...prev,
        [name]: value || null,
      }));
      setPayloadToSend((prev) => ({
        ...prev,
        configuracionSesionNxt: {
          ...prev.configuracionSesionNxt,
          tipoTrabajo: tipoTrabajoSeleccionado || null,
        }, // Asegúrate de que nunca sea undefined
      }));
    } else {
      setPayload((prev) => ({ ...prev, [name]: value }));
      setPayloadToSend((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handlePermissionsChange = (newPermissions) => {
    const permisosActualizados = permissions.map((permiso) => ({
      ...permiso,
      seleccionado: newPermissions.includes(String(permiso.id)) ? true : false,
    }));
    setPayload((prev) => ({ ...prev, permisos: permisosActualizados }));
    setPayloadToSend((prev) => ({ ...prev, permisos: permisosActualizados }));
  };

  const handleSave = () => {
    const formattedPayload = {
      ...payloadtoSend,
      id: null,
    };

    createUser(API_URL, formattedPayload);
  };

  const addUser = () => (
    <div className="form-container">
      <form>
        {fieldsAddUser.map((field) => (
          <div className="form-row" key={field.name}>
            {(field.name !== "permisionario" &&
              (payload.perfil === "PROJECT_MANAGER" ||
                !["empresa", "tipoTrabajo", "proyecto", "cliente"].includes(
                  field.name
                ))) ||
            (payload.perfil === "PROJECT_MANAGER" &&
              payload.cliente &&
              field.name === "permisionario") ? (
              <label className="form-label">
                {field.name === "lenguaje" ? "Idioma" : field.label}:
              </label>
            ) : null}

            {field.name === "perfil" ? (
              <CustomSelect
                options={perfiles.map((perfil) => ({
                  value: perfil.name,
                  name: perfil.descripcion,
                  icon: perfil.icon,
                }))}
                value={payload[field.name] || ""}
                name={field.name}
                onChange={handleChange}
                width={"500px"}
                height={"39px"}
                textAlign={"left"}
                color={"#6c757d"}
                fontSize={"14px"}
                fontWeight={600}
                paddingTop={"8px"}
                marginBottom={"6px"}
              />
            ) : field.name === "empresa" ? (
              payload.perfil === "PROJECT_MANAGER" && (
                <CustomSelect
                  options={companies.map((company) => ({
                    value: company.id,
                    name: company.razonSocial,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={"500px"}
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                  placeholder="Seleccione una empresa"
                  overflowY={"scroll"}
                />
              )
            ) : field.name === "lenguaje" ? (
              <CustomSelect
                options={language.map((language) => ({
                  value: language.prefix,
                  name:
                    language.name === "ESPANOL"
                      ? "Español"
                      : language.name === "PORTUGUES"
                      ? "Portugués"
                      : language.name === "INGLES"
                      ? "Inglés"
                      : language.name, // Mantén el nombre original si no coincide ,
                }))}
                value={payload[field.name] || ""}
                name={field.name}
                onChange={handleChange}
                width={"500px"}
                height={"39px"}
                textAlign={"left"}
                color={"#6c757d"}
                fontSize={"14px"}
                fontWeight={600}
                paddingTop={"8px"}
                marginBottom={"6px"}
                placeholder="Seleccione un idioma"
                heightOption={"60px"}
                topOption={"-50px"}
              />
            ) : field.name === "tipoTrabajo" ? (
              payload.perfil === "PROJECT_MANAGER" && (
                <CustomSelect
                  options={typeWorks.map((typeWork) => ({
                    value: typeWork.id,
                    name: typeWork.nombre,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={"500px"}
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                  placeholder="Seleccione un tipo de trabajo"
                  overflowY={"scroll"}
                />
              )
            ) : field.name === "permisos" ? (
              <PermissionsSelector
                permissions={permissions}
                selectedPermissions={
                  payload.permisos
                    ?.filter((p) => p.seleccionado)
                    .map((p) => p.id) || []
                }
                onChange={handlePermissionsChange}
              />
            ) : field.name === "proyecto" ? (
              payload.perfil === "PROJECT_MANAGER" && (
                <CustomSelect
                  options={projects.map((project) => ({
                    value: project.id,
                    name: project.nombre,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={"500px"}
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                  placeholder="Seleccione un proyecto"
                  overflowY={"scroll"}
                />
              )
            ) : field.name === "cliente" ? (
              payload.perfil === "PROJECT_MANAGER" && (
                <CustomSelect
                  options={clients.map((client) => ({
                    value: client.id,
                    name: client.razonSocial,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={"500px"}
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                  placeholder="Seleccione un cliente"
                  overflowY={"scroll"}
                />
              )
            ) : field.name === "permisionario" ? (
              payloadtoSend.configuracionSesionNxt.cliente !== null && (
                <CustomSelect
                  options={permisionarios.map((permisionario) => ({
                    value: permisionario.id,
                    name: permisionario.razonSocial,
                  }))}
                  value={payload[field.name] || ""}
                  name={field.name}
                  onChange={handleChange}
                  width={"500px"}
                  height={"39px"}
                  textAlign={"left"}
                  color={"#6c757d"}
                  fontSize={"14px"}
                  fontWeight={600}
                  paddingTop={"8px"}
                  marginBottom={"6px"}
                  placeholder="Seleccione un permisionario"
                  heightOption={"auto"}
                  topOption={"-0px"}
                />
              )
            ) : (
              <input
                className="form-input"
                type="text"
                name={field.name}
                value={payload[field.name] || ""}
                onChange={handleChange}
                placeholder={`Ingresa ${field.label.toLowerCase()}`}
              />
            )}
          </div>
        ))}
        <div className="button-container">
          <CustomButton
            text={"Guardar"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"75px"}
            height={"28px"}
            type={"button"}
            onClick={() => handleSave()}
          />
        </div>
      </form>
    </div>
  );

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ width: "12rem" }}>
        <SideMenu />
      </div>
      <div className="createUser">
        <ToggleViews
          views={[{ name: "Registro individual", content: addUser() }]}
        />
      </div>
    </div>
  );
};

export default CreateUser;
